import { FunctionComponent,useState ,useEffect,useContext, ChangeEvent} from "react";
import TitleText from "../../components/shared-components/dashboard/TitleText";
import AppTable from "../../components/shared-components/table/AppTable";
import styles from "./Users.module.css";
import images from "../../assets/images";
import { CircularProgress, Menu, MenuItem } from "@mui/material";
import { GET_MARKETING_USERS, GET_USERS_LIST, SEND_VERIFICATION, UPDATE_USER } from "./api/UsersQuery";
import { useLazyQuery , useMutation} from "@apollo/client";
import ToasterWithMessage from "../../components/shared-components/toaster";
import { globalContext } from "../../Provider/AppProvider";
import { generateDynamicLinkForNotVerifiedUsers, getFormattedDate, roles, rowsType } from "../../helper";
import { GET_NOTIFICATIONS } from "../../components/shared-components/notification/api/NotificationQuery";


const Users: FunctionComponent = () => {
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('errorTabIndex');
  localStorage.removeItem('settingsTabIndex');
  const title = "Users";
  const { dropdownIcon } = images;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [tempRowsPerPage, setTempRowsPerPage] = useState<string>();
  const [rowsPerPage, setRowsPerPage] = useState(parseInt(tempRowsPerPage ? tempRowsPerPage : '') || 10);
  const [currentPage, setCurrentPage] = useState(1);
  const [checking,setChecking]=useState<boolean>(false);
  const {error,success} = ToasterWithMessage();
  const [userslist,setUsersList] = useState<any>([{}]);
  const [selected, setSelected] = useState<number[]>([]);
  const [columnTypes, setColumnTypes] = useState<string>('u_updated_at');
  const [sortType, setSortType] = useState<string>('desc');
  const [selectedUsersToVerify,setSelectedUsersToVerify] = useState<any>();
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [selectedUsers,setSelectedUsers] = useState<string[]>([]);
  const [ifDelete,setIfDelete] = useState<boolean>(false);
  const [userCount,setUserCount] = useState<number>(0);
  const [searchvalue, setSearchvalue] = useState(globalState.globalSearch.searchtext)
  const date = getFormattedDate(new Date());

  useEffect(() => {
    const tempdata = {...globalState}
    setSearchvalue(tempdata.globalSearch.searchtext)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState.globalSearch.searchtext])

  const [getNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempState = {...globalState}
      tempState.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempState.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempState)
    }
  })

  useEffect(()=>{
    const tempvaluestate = {...globalState}
    if(globalState.notification.notificationClicked){
      tempvaluestate.notification.notificationClicked = false;
      tempvaluestate.notification.tp_id_array=null;
      tempvaluestate.globalSearch.searchtext = "";
      tempvaluestate.notification.text = "";
      tempvaluestate.notification.ticketId =null;
      tempvaluestate.notification.tpId = null;
    }else if(globalState.error.errorClicked){
      tempvaluestate.error.errorClicked = false;
      tempvaluestate.globalSearch.searchtext = "";
      tempvaluestate.error.text = "";
      tempvaluestate.error.approximateTpArray = null
      tempvaluestate.error.ticketPlacementId = null
      tempvaluestate.error.status = ""
    }else if(globalState.soldTickets.failed){
      tempvaluestate.soldTickets.failed = false
      tempvaluestate.globalSearch.searchtext = "";
      tempvaluestate.soldTickets.emailId = "";
    }
    handleGlobalState(tempvaluestate)
    if(globalState.profile.userRole !== "marketing_user"){
      getNotification({
        variables:{
          todayDate: date,
          userId: globalState?.profile?.id
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const [getUsersList,{loading}] = useLazyQuery(globalState.profile.userRole === "marketing_user" ? 
    GET_MARKETING_USERS: GET_USERS_LIST ,{
    fetchPolicy :'no-cache',
    onCompleted: (data)=>{
        setUsersList(data)
    },
    onError: () =>{
          error("Something went wrong!")
    }
  })

  const callGetUsersApi = () => {
    getUsersList({variables:{
      pageSize: rowsPerPage,
      pageOffset: (currentPage -1)*rowsPerPage,
      order_by: columnTypes=== 't_active_tickets' || columnTypes === 't_sold_tickets'?
      {
        tickets_aggregate : {sum : {[columnTypes]: sortType === 'desc' ? 'desc_nulls_last' : 'asc_nulls_first'}}
      }: 
      columnTypes === 'ur_joining_code' ?  {user_referred_to: {user_referred_by:{u_full_name : sortType}}} :
      columnTypes === 'number of referrals' ? {user_referred_by_aggregate: {count: sortType}} :
      {[columnTypes]: sortType},
      searchText: `%${searchvalue}%`
    }})
  }
  const [updateBulkUser,{loading: updateLoading}] = useMutation(UPDATE_USER,{
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      if(ifDelete){
        // eslint-disable-next-line no-lone-blocks
        {userCount === 1 
          ? success(`${userCount} user deleted successfully`) 
          : success(`${userCount} users deleted successfully`)
        }
        setIfDelete(false);
      }else{
        // eslint-disable-next-line no-lone-blocks
        {userCount === 1
        ? success(`${userCount} user updated successfully`)
        : success(`${userCount} users updated successfully`)
        }
      }
      setUserCount(0);
      setCurrentPage(1);
      callGetUsersApi();
      setSelectedUsers([]);
    },
    onError: () =>{
      setIfDelete(false);
      setUserCount(0);
      setSelected([]);
      setSelectedUsers([]);
      error("Something went wrong!");
    }
  })
  useEffect(()=>{
    if(globalState.userUpdate.updated){
      callGetUsersApi();
    }
    const tempState = {...globalState};
    tempState.userUpdate.updated = false;
    handleGlobalState(tempState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState.userUpdate.updated])
  const handleClickOpenmenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setTempRowsPerPage(event.target.value);
    setSelected([])
    setSelectedUsers([])
    setSelectedUsersToVerify([]);
  };

  const handlePageChange = (_event: ChangeEvent<unknown>, newPage: number) => {
    setCurrentPage(newPage);
    setChecking(false)
    setSelected([]);
    setSelectedUsers([])
    setSelectedUsersToVerify([]);
  };

  useEffect(()=>{
    callGetUsersApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[rowsPerPage,currentPage,sortType,columnTypes,searchvalue]);

  useEffect(()=>{
    callGetUsersApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[searchvalue]);

  const GenerateUsersHeadCells = ()=>{
    let id = ["u_first_name","u_stripe_business_name","u_email_id","u_phone_number","u_is_active","u_id","reason","u_delete_requested","ur_joining_code","t_active_tickets","t_sold_tickets","tickets_sold_amount","u_stripe_account_id","u_last_online",'u_created_at',"action"];
    let labels = ["User Name","Business Name","Email","Phone Number","Status", "User Id","Reason","Delete Request","Referred By","Active Ticket","Sold Tickets","Sold Amount","Stripe Id","Last Login","Member Since","Action"];
    if(globalState.profile.userRole === "marketing_user"){
      id = ["u_first_name","u_stripe_business_name","u_email_id","u_phone_number","u_is_active","u_id","reason","u_delete_requested","ur_joining_code","t_active_tickets","t_sold_tickets","tickets_sold_amount","u_last_online",'u_created_at'];
      labels = ["User Name","Business Name","Email","Phone Number","Status","User Id","Reason","Delete Request","Referred By","Active Ticket","Sold Tickets","Sold Amount","Last Login","Member Since"];
    } else if(globalState.profile.userRole === roles.AFFILIATER_ADMIN) {
      id = ["u_first_name","u_stripe_business_name","u_email_id","u_phone_number","u_is_active","u_id","reason","u_delete_requested","ur_joining_code","t_active_tickets","t_sold_tickets","tickets_sold_amount","u_stripe_account_id","u_last_online",'u_created_at'];
      labels = ["User Name","Business Name","Email","Phone Number","Status", "User Id","Reason","Delete Request","Referred By","Active Ticket","Sold Tickets","Sold Amount","Stripe Id","Last Login","Member Since"];
    }
    const headCells = id.map((id, index) => ({
        id,
        label: labels[index],
      }));
      return headCells;
}

const [sendVerificationLinkBulk] = useMutation(SEND_VERIFICATION,{
  fetchPolicy: 'no-cache',
  onCompleted: (data) => {
    setSelected([]);
    setSelectedUsersToVerify(() => []);
    if(userCount === 1){
      success(`Mail sent successfully to ${userCount} user`);
    }else {
      success(`Mail sent successfully to ${userCount} users`);
    }
    setUserCount(0);
    const tempState = {...globalState};
    tempState.userUpdate.updated = true;
    handleGlobalState(tempState);
  },
  onError: (err) => {
    setSelected([]);
    setSelectedUsersToVerify([]);
    setUserCount(0);
    error("Something went wrong!");
  }
})

 const sendMailToUsers = async () => {
      handleClose();
      if(selectedUsersToVerify.length > 0){
        const toBeSentMailForVerify = await Promise.all(
          selectedUsersToVerify?.filter((user: rowsType) => (user?.u_is_active === false) && (user?.u_is_verified === false))
                                .map(async (userDetail: rowsType) => {
                                  return {emailId: userDetail?.u_email_id,link: await generateDynamicLinkForNotVerifiedUsers(userDetail)}
                                })
        );
        if(toBeSentMailForVerify.length > 0){
          setUserCount(toBeSentMailForVerify.length);
          sendVerificationLinkBulk({
            variables: {
              verifyUserInput: toBeSentMailForVerify
            }
          })
          setSelected([]);
          setSelectedUsersToVerify([]);
        }else{
          error("Please select not verified users");
          setSelected([]);
          setSelectedUsersToVerify([]);
        }
      }else {
        error("Please select the users")
        setSelected([]);
        setSelectedUsersToVerify([]);
      }
 }
 const ApiCall = (activeOrInactivestate: boolean | null, deleteState:boolean)=>{
    handleClose();
    if(selectedUsers.length > 0){
            let toBeActivateusers : string[]= [];
            let toBeDeactivateusers : string[] = [];
            let activeUsers : string[]= [];
            let notVerifiedUsers : string[] = []; 
            let deactiveUsers : string[] = [];
            if(activeOrInactivestate === true){
              selectedUsers?.map((id: string)=>{
                      return userslist?.user?.map((user: rowsType) => {
                            if(id === user?.u_id){
                              if((user?.u_is_active === false) && (user?.u_is_verified === true)){
                                  toBeActivateusers.push(user?.u_id);
                              }else if((user?.u_is_active === true)){
                                activeUsers.push(user?.u_id);
                              }else if(user?.u_is_verified === false){
                                notVerifiedUsers.push(user?.u_id)
                              }
                            }
                            return user?.u_id;
                      })
              })
              //  && 
              if(activeUsers.length > 0 && notVerifiedUsers.length === 0 && toBeActivateusers.length === 0){
                error(`Can't activate active users`)
              }else if(notVerifiedUsers.length > 0 && activeUsers.length > 0){
                error('Active and not verified users exists')
              }else if(notVerifiedUsers.length > 0){
                error('No verified users found')
              }
              //  && toBeActivateusers.length === 0 && 
            }else if(activeOrInactivestate === false){
              selectedUsers?.map((id: string)=>{
                return userslist?.user?.map((user: rowsType) => {
                      if(id === user?.u_id){
                        if((user?.u_is_active === true) && (user?.u_is_verified === true)){
                            toBeDeactivateusers.push(user?.u_id);
                        }else if((user?.u_is_active === false)){
                          deactiveUsers.push(user?.u_id);
                        }else if(user?.u_is_verified === false){
                          notVerifiedUsers.push(user?.u_id)
                        }
                      }
                      return user?.u_id;
                })
              })
              if(deactiveUsers.length > 0 && notVerifiedUsers.length === 0 && toBeDeactivateusers.length === 0){
                error(`Can't deactivate, deactive users`)
              }else if(notVerifiedUsers.length > 0 && deactiveUsers.length > 0){
                error('Deactivate and not verified users exists')
              }else if(notVerifiedUsers.length > 0){
                error('No verified users found')
              }
            }
            if(toBeActivateusers.length > 0){
              setUserCount(toBeActivateusers.length);
              setColumnTypes("u_updated_at");
              setSortType("desc");
              updateBulkUser({
                variables:{
                  userStatusInput: {
                    activeInActive: activeOrInactivestate,
                    deletedAt: deleteState,
                    userId: toBeActivateusers
                  }
                }
              });
            }else if(toBeDeactivateusers.length > 0 ){
              setUserCount(toBeDeactivateusers.length);
              setColumnTypes("u_updated_at");
              setSortType("desc");
              updateBulkUser({
                variables:{
                  userStatusInput: {
                    activeInActive: activeOrInactivestate,
                    deletedAt: deleteState,
                    userId: toBeDeactivateusers
                  }
                }
              });
            }else if(deleteState === true){
              const toBeDeleted = userslist?.user?.filter((data: rowsType) => {
                                                  if (
                                                      selectedUsers.includes(data?.u_id) &&
                                                      !(data?.tickets_aggregate?.aggregate?.sum?.t_active_tickets > 0) &&
                                                      !(data?.tickets_aggregate?.aggregate?.sum?.t_sold_tickets > 0)
                                                  ) {
                                                      return true; 
                                                  }
                                                  return false;
                                              })
                                              .map((data: rowsType) => data?.u_id);
              if(toBeDeleted.length > 0){
                setIfDelete(deleteState);
                setUserCount(toBeDeleted.length);
                setColumnTypes("u_updated_at");
                setSortType("desc");
                updateBulkUser({
                  variables:{
                    userStatusInput: {
                      activeInActive: activeOrInactivestate,
                      deletedAt: deleteState,
                      userId: toBeDeleted
                    }
                  }
                });
              }else{
                error("Can't delete users who have tickets")
              }
            }
            setSelected([]);
            setSelectedUsers([]);
    } else {
         error('Please select the users');
    }
 }

   return (
     <div style={{ width: "100%" }}>
       <>
         <div className={styles.userHeading}>
           <TitleText title={title} />
          {(globalState.globalSearch.searchtext !== '' && !globalState.error.userError) && <div className={styles.filterResultCount}><span className={styles.filterCount}>Search Results({userslist?.user_aggregate?.aggregate?.count})</span></div>}
          {(globalState.globalSearch.searchtext !== '' && globalState.error.userError) && <div className={styles.filterResultCount}><span className={styles.filterCount}>Error Filter Results({userslist?.user_aggregate?.aggregate?.count})</span></div>}
           {(globalState.profile.userRole === roles.MARKETING_USER || globalState.profile.userRole === roles.AFFILIATER_ADMIN) ? null :<div className={styles.bulkaction} onClick={handleClickOpenmenu}>
             <div>Bulk Action</div>
             <div className={styles.dropdown}>
               <img src={dropdownIcon} alt="dropdownIcon" />
             </div>
           </div>}
           <Menu
             id="long-menu"
             MenuListProps={{
               "aria-labelledby": "long-button",
               disablePadding: true,
             }}
             transformOrigin={{
               horizontal: "right",
               vertical: "top",
             }}
             anchorOrigin={{
               horizontal: "right",
               vertical: "bottom",
             }}
             anchorEl={anchorEl}
             open={open}
             onClose={handleClose}
             classes={{
               paper: styles.actionDropdown,
             }}
           >
             <div className={styles.bulkActionDropdown}>
              <MenuItem className={styles.menuItemActivateStyle} onClick={()=> ApiCall(true,false)}>Activate</MenuItem>
              <MenuItem className={styles.menuItemDeactivateStyle} onClick={()=> ApiCall(false,false)}>Deactivate</MenuItem>
              <MenuItem className={styles.menuItemVerificationStyle} onClick={()=> sendMailToUsers()}>Send Verification</MenuItem>
              <MenuItem className={styles.menuItemDeleteStyle} onClick={() => ApiCall(null,true)}>Delete</MenuItem>
            </div>
           </Menu>
         </div>

         {(loading || updateLoading || globalState.usersPageLoader.updateLoader)
            ?
                <div className={styles.TableCircularProgress}>
                <CircularProgress color="primary" size={35} />
                </div>
           :   
         <AppTable
           handleChangeRowsPerPage={handleChangeRowsPerPage}
           handlePageChange={handlePageChange}
           setColumnTypes = {setColumnTypes}
           sortType = {sortType}
           setSortType = {setSortType}
           setSelected = {setSelected}
           setChecking = {setChecking}
           checking = {checking}
           selected ={selected}
           rowsPerPage = {rowsPerPage}
           setCurrentPage={setCurrentPage}
           currentPage= {currentPage}
           list={userslist}
           tableTitle = "users"
           generateHeadCells = {GenerateUsersHeadCells}
           selectedUsers = {selectedUsers}
           setSelectedUsers= {setSelectedUsers}
           setSelectedUsersToVerify={setSelectedUsersToVerify}
           setUsersList = {setUsersList}
         />
         }
       </>
     </div>
   );
};

export default Users;
